import { render, staticRenderFns } from "./Step_2.vue?vue&type=template&id=165d182f&scoped=true&"
import script from "./Step_2.vue?vue&type=script&lang=js&"
export * from "./Step_2.vue?vue&type=script&lang=js&"
import style0 from "./Step_2.vue?vue&type=style&index=0&id=165d182f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165d182f",
  null
  
)

export default component.exports